import { BaseApi } from '../baseApi';
import { APIResponse, UserProfileResponse } from '@/types/api';
import type { 
  StudentProfileResponse, 
  TeacherProfileResponse, 
  OrganizationProfileResponse 
} from '@/types/api';

export class ProfileApi extends BaseApi {
    // Student Profile Methods
    async getStudentProfile(): Promise<APIResponse<UserProfileResponse>> {
        return this.makeGet<APIResponse<UserProfileResponse>>('/profile/student');
    }

    async updateStudentProfile(data: Partial<StudentProfileResponse>): Promise<APIResponse<UserProfileResponse>> {
        return this.makePut<APIResponse<UserProfileResponse>>('/profile/student', data);
    }

    // Teacher Profile Methods
    async getTeacherProfile(): Promise<APIResponse<UserProfileResponse>> {
        return this.makeGet<APIResponse<UserProfileResponse>>('/profile/teacher');
    }

    async updateTeacherProfile(data: Partial<TeacherProfileResponse>): Promise<APIResponse<UserProfileResponse>> {
        return this.makePut<APIResponse<UserProfileResponse>>('/profile/teacher', data);
    }

    // Organization Profile Methods
    async getOrganizationProfile(): Promise<APIResponse<UserProfileResponse>> {
        return this.makeGet<APIResponse<UserProfileResponse>>('/profile/organization');
    }

    async updateOrganizationProfile(data: Partial<OrganizationProfileResponse>): Promise<APIResponse<UserProfileResponse>> {
        return this.makePut<APIResponse<UserProfileResponse>>('/profile/organization', data);
    }
} 